import { render } from "./IconCross.vue?vue&type=template&id=d6d97d78"
import script from "./IconCross.vue?vue&type=script&lang=js"
export * from "./IconCross.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__